import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { Button, Card, Col, Form, notification, Row, Spin } from 'antd'
import _ from 'lodash'
import { goBack } from 'connected-react-router'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import { connect } from 'react-redux'
import styles from './styles.less'
import moment from "moment/moment";

@Form.create()
class UpdateBranchInvoice extends PureComponent {

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let { dueInvoiceId, inquiryId } = this.state
                let values = _.clone(valData)
                dispatch(showLoader())


                valData._id = inquiryId
                valData.dueInvoiceId = dueInvoiceId

                let x = await Request.updateInvoice(valData)

                dispatch(hideLoader())
                if (!x.error) {

                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })
                    dispatch(goBack())

                    this.props.form.resetFields()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }

    constructor(props) {
        super(props)
        this.state = { loader: true }

    }

    async componentWillMount() {
        let { userRights } = await Request.loadUserRights()
        this.setState({ claimDeskRights: userRights.ClaimDesk },
            () => {

                console.log(this.state.claimDeskRights)
            })
    }

    async componentDidMount() {
        const { form } = this.props
        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')
        let dueInvoiceId = searchParams.get('dueInvoiceId')
        let { doc } = await Request.getInquiry(inquiryId)

        if (doc) {
            let channelPartnerId = doc.visaDesk && doc.visaDesk.channelPartnerId
            if (doc.leadSource == 'Channel Partner') {
                let { doc: channelPartner } = await Request.getPartner(channelPartnerId)
                this.setState({
                    channelPartnerName: channelPartner && channelPartner.channelPartnerName,
                })
            }

            if (inquiryId && dueInvoiceId) {

                let found = _.find(doc && doc.dueInvoices, (item) => {
                    return item._id == dueInvoiceId
                })
                if (found) {
                    form.setFieldsValue({
                        branchCommission: found.branchCommission,
                        uploadBranchInvoice: found.uploadBranchInvoice,
                        uploadBranchSignedInvoice: found.uploadBranchSignedInvoice,
                        uploadBranchPaymentProof: found.uploadBranchPaymentProof
                    })
                    this.setState({
                        singleDueInvoice: found
                    })


                }
            }
            this.setState({
                inquiryId: inquiryId,
                dueInvoiceId: dueInvoiceId,
                info: doc,
                visaDesk: doc && doc.visaDesk,
                loader: false

            })

        } else {
            this.setState({ loader: false })
        }


    }

    render() {
        const { dispatch, form: { getFieldDecorator, getFieldValue } } = this.props
        const { claimDeskRights, singleDueInvoice, info, visaDesk, channelPartnerName } = this.state

        const inputSchema = {
            fields: [
                {
                    label: 'Branch Commission ', key: 'branchCommission', type: 'number',
                    rightComp: <span style={{ paddingLeft: '5px' }}>%</span>
                },
                {
                    label: 'Upload Invoice',
                    key: 'uploadBranchInvoice',
                    type: 'file',
                    prefixComp:
                        <div className={styles.downloadFile}>
                            <div className={styles.downloadFile1}>
                                {singleDueInvoice && singleDueInvoice.uploadBranchInvoice && singleDueInvoice.uploadBranchInvoice.length > 0 &&
                                    <Button
                                        icon="download"
                                        size={'small'}
                                        onClick={() => {
                                            window.open(
                                                `${MEDIA_URL}/${singleDueInvoice.uploadBranchInvoice[0].url}`,
                                                '_blank'
                                            )
                                        }} />}

                            </div>
                        </div>
                },
                {
                    label: 'Upload Signed Invoice',
                    key: 'uploadBranchSignedInvoice',
                    type: 'file',
                    prefixComp: <div className={styles.downloadFile}>
                        <div className={styles.downloadFile1}>
                            {singleDueInvoice && singleDueInvoice.uploadBranchInvoice && singleDueInvoice.uploadBranchInvoice.length > 0 &&
                                <Button
                                    icon="download"
                                    size={'small'}
                                    onClick={() => {
                                        window.open(
                                            `${MEDIA_URL}/${singleDueInvoice.uploadBranchSignedInvoice[0].url}`,
                                            '_blank'
                                        )
                                    }} />}
                        </div>
                    </div>
                },
                {
                    label: 'Upload Payment Proof',
                    key: 'uploadBranchPaymentProof',
                    type: 'file',
                    prefixComp: <div className={styles.downloadFile}>
                        <div className={styles.downloadFile1}>
                            {singleDueInvoice && singleDueInvoice.uploadBranchInvoice && singleDueInvoice.uploadBranchInvoice.length > 0 &&
                                <Button
                                    icon="download"
                                    size={'small'}
                                    onClick={() => {
                                        window.open(
                                            `${MEDIA_URL}/${singleDueInvoice.uploadBranchSignedInvoice[0].url}`,
                                            '_blank'
                                        )
                                    }} />}
                        </div>
                    </div>
                }

            ]
        }

        const inputSchema2 = {
            fields: [

                {
                    label: 'Upload Signed Invoice',
                    prefixComp: <div className={styles.downloadFile}>
                        <div className={styles.downloadFile1}>
                            {singleDueInvoice && singleDueInvoice.uploadBranchInvoice && singleDueInvoice.uploadBranchInvoice.length > 0 &&
                                <Button
                                    icon="download"
                                    size={'small'}
                                    onClick={() => {
                                        window.open(
                                            `${MEDIA_URL}/${singleDueInvoice.uploadBranchSignedInvoice[0].url}`,
                                            '_blank'
                                        )
                                    }} />}
                        </div>
                    </div>,
                    key: 'uploadBranchSignedInvoice',
                    type: 'file'
                }
            ]
        }
        let formButtton = <div><Button
            htmlType="submit"
            style={{
                marginTop: '10px',
                marginLeft: '26px',
                backgroundColor: '#85CF4A',
                border: '1px solid #85CF4A',
                color: 'white'
            }}
            loading={this.props.loading}>
            Update Branch Invoice
        </Button></div>
        return (
            <PageHeaderWrapper title={'Update Branch/Associate Partner Invoice'}>
                <Spin spinning={this.state.loader}>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <Card bordered={true}>
                            <Row>
                                <Col span={8}>
                                    <table className={styles.dataTable}>
                                        <tbody>
                                            <tr>
                                                <td>Student Name</td>
                                                <td>{info && info.studentName}</td>
                                            </tr>
                                            <tr>
                                                <td>Mobile</td>
                                                <td>{info && info.mobile}</td>
                                            </tr>
                                            <tr>
                                                <td>DOB</td>
                                                <td>{info && info.dateOfBirth ? moment(info.dateOfBirth).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>Branch</td>
                                                <td>{info && info.studentBranchId && info.studentBranchId.branchName}</td>
                                            </tr>
                                            <tr>
                                                <td>Current Desk</td>
                                                <td>{info && info.atLevel}</td>
                                            </tr>
                                            <tr>
                                                <td>Visa Approval Date</td>
                                                <td>{info && info.visaDesk && info.visaDesk.visaApprovalDate ? moment(info.visaDesk.visaApprovalDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            {claimDeskRights && claimDeskRights.viewByBranch && <tr>
                                                <td>Arrival Date</td>
                                                <td>{visaDesk && visaDesk.arrivalDate ? moment(visaDesk.arrivalDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>}


                                            <tr>
                                                <td>Passport No.</td>
                                                <td>{visaDesk && visaDesk.passportNo}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoicee</td>
                                                <td>
                                                    <div>{info && info.leadSource == 'Channel Partner' ? info.leadSource : 'University'}</div>
                                                    <small>{info && info.leadSource == 'Channel Partner' ? channelPartnerName : ''}</small>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Course Start Date</td>

                                                <td>{visaDesk && visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>University Name</td>
                                                <td>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.universityInstitutionName}</td>
                                            </tr>
                                            <tr>
                                                <td>Course Name</td>
                                                <td>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseName}</td>
                                            </tr>
                                            <tr>
                                                <td>Student Status</td>
                                                <td>{info && info.studentStatus}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoice Status</td>
                                                <td>{info && info.invoiceStatus}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </Col>
                                <Col span={16}>

                                    {claimDeskRights && claimDeskRights.viewByBranch ? <React.Fragment>
                                        <GetAllFormFields
                                            inputSchema={inputSchema2}
                                            loading={this.props.loading}
                                            apiurl={LAPI_URL}
                                            getFieldDecorator={getFieldDecorator}
                                            formItemLayout={{
                                                labelCol: { span: 6 },
                                                wrapperCol: { span: 14 }
                                            }}


                                        />
                                        {formButtton}
                                    </React.Fragment> : <React.Fragment>
                                        <GetAllFormFields
                                            inputSchema={inputSchema}
                                            loading={this.props.loading}
                                            apiurl={LAPI_URL}
                                            getFieldDecorator={getFieldDecorator}
                                            formItemLayout={{
                                                labelCol: { span: 6 },
                                                wrapperCol: { span: 14 }
                                            }}

                                        />
                                        {formButtton}

                                    </React.Fragment>


                                    }


                                </Col>
                            </Row>


                        </Card>


                    </Form>
                </Spin>


            </PageHeaderWrapper>
        )
    }
}

const
    mapStateToProps = ({ global, router }) => ({
        loading: global.buttonLoading,
        categories: global.categories,
        allChannelPartners: global.allChannelPartners,
        search: router.location.search
    })
const
    mapDispatchToProps = dispatch => {
        return {
            dispatch
        }
    }
export default connect(mapStateToProps,
    mapDispatchToProps)

    (
        UpdateBranchInvoice
    )


